<template>
  <span
    :class="[
      linkSize === 'compact' ? 'caption' : 'body-2',
      'flex items-center',
      boxedIcon ? '' : 'inline-flex gap-4',
    ]"
    data-qa="delivery-postal-code-trigger"
  >
    <span
      v-if="boxedIcon"
      class="-mr-8 flex w-40 shrink-0 items-center justify-center"
    >
      <IconLocationPinFilled class="h-16 w-16" />
    </span>
    <IconLocationPinFilled v-else class="h-16 w-16" />
    <RevLink v-if="!postalCode" @click="handleOpen">
      {{ i18n(translations.updateLabel) }}
    </RevLink>
    <FormattedMessage v-else :definition="translations.shipToLabel">
      <template #postalCode>
        <RevLink @click="handleOpen">{{ postalCode }}</RevLink>
      </template>
    </FormattedMessage>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconLocationPinFilled } from '@ds/icons/IconLocationPinFilled'

import { useDeliveryPostalCode } from '~/scopes/shipping/composables/useDeliveryPostalCode/useDeliveryPostalCode'

import translations from './DeliveryPostalCodeModal.translations'

const props = withDefaults(
  defineProps<{
    entryPoint: 'pdp' | 'cart' | 'nav'
    boxedIcon?: boolean
    trackingContext?: 'web' | 'mweb' | 'recap'
    linkSize?: 'default' | 'compact'
  }>(),
  {
    trackingContext: undefined,
    linkSize: 'default',
  },
)

const i18n = useI18n()
const { postalCode } = useDeliveryPostalCode()

const modalName = computed(() =>
  props.trackingContext
    ? `postalcode_delivery_promise_${props.entryPoint}_${props.trackingContext}`
    : `postalcode_delivery_promise_${props.entryPoint}`,
)

function handleOpen(event: MouseEvent) {
  openModal(modalName.value, event)
}
</script>
